import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var sourceDataConst = [{
  transfer: '一月',
  value: 813
}, {
  transfer: '二月',
  value: 233
}, {
  transfer: '三月',
  value: 561
}];
export default {
  name: 'Liquid',
  props: {
    height: {
      type: Number,
      default: 0
    },
    width: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      data: sourceDataConst,
      scale: []
    };
  }
};